import { Flex } from "reflexbox";
import styled from "styled-components";

const MainContainer = styled(Flex)`
  width: 100%;
  justify-content: center;
`;

const SecondaryContainer = styled(Flex)`
  margin-bottom: 5%;
  flex-direction: column;
  margin-top: 60px;
`;

const ParticipantDetailsContainer = styled(Flex)`
  margin-bottom: 5%;
  flex-direction: column;
  margin-top: 20px;
`;

export {
  MainContainer,
  SecondaryContainer,
  ParticipantDetailsContainer
}